import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnyType } from '@thehubz/shared/model';

interface AssetItemBasic {
  previewUrl: string;
  name: string;
  assetType: string;
  imageUrl?: string;
  checked?: boolean;
}

@Component({
  selector: 'thehubz-collection-select-view',
  templateUrl: './collection-select-view.component.html',
  styleUrls: ['./collection-select-view.component.scss'],
})
export class CollectionSelectViewComponent {
  @Input() item!: AnyType;
  @Input() editFlag?: boolean;
  @Input() disableCheckbox?: boolean;
  @Input() index?: number;
  @Input() published?: boolean;
  @Output() updateSelection = new EventEmitter();

  assetId: string;

  constructor() {
    this.assetId = String(Math.random() * Date.now());
  }

  onChangeSelectedCollection(evt: AnyType, item: AssetItemBasic, index?: number, published?: boolean) {
    this.updateSelection.emit({ evt, item, index, published });
  }
}
